export const eng = {
    id: 'ID',
    add: 'Add',
    address: 'Address',
    cancel: 'Cancel',
    confirm: 'Are you sure?',
    contract: 'Contract',
    email: 'Email',
    firstname: 'First name',
    lang: "En",
    lastname: 'Last name',
    login: 'Login',
    loginTitle: 'Sign in',
    name: 'Name',
    networkError: 'Server connection error',
    no: 'No',
    noData: 'No data',
    noRoutes: 'The administrator has not assigned you a route',
    ok: 'Yes',
    password: 'Password',
    phone: 'Phone number',
    price: 'Price',
    product: 'Product',
    registration: 'Registration',
    repeatThePassword: 'Repeat the password',
    required: 'Please enter {{input}}!',
    role: 'Role',
    save: 'Save',
    store: 'Warehouse',
    update: 'Update',
    username: 'Username',
    ROLE_ADMIN: "ADMIN",
    ROLE_USER: "USER",
    action: "Actions",
    search: "Search {{name}}",
    year: "Year",
    month: "Month",
    day: "Day",
    hour: "Hour",
    minute: "Minute",
    second: "Second",
    sectionAccess: "Section access",
    delete: 'Delete',
    select: 'Select',
    from: 'from',
    to: 'to',
    selectPage: 'Select page',
    nds: 'VAT',
    noPermission: 'No permission',
    permission: 'Permission',
    empty: '(empty)',
    fullName: 'Full name',
    users: 'Users',
    region: 'Region',
    inn: 'INN',
    code: "Code",
    mfo: 'MFO',
    hide: 'Hide',
    history: 'History',
    createdDate: 'Created date',
    size: 'Size',
    download: 'Download',
    delete_confirm: 'Are you sure you want to delete?',
    status: 'Status',
    bank: 'Bank',
    productName: 'Product name',
    invoiceNum: 'Invoice number',
    expirationDate: 'Expiration date',
    document: "Document",
    act: "Act",
    acceptAccount: "Accept account",
    returnAct: "Return act",
    returnActAccepted: "Return act accepted",
    selectSumma: "Select summa",
    summaWithoutVat: "Amount without VAT",
    urgentToView: "Urgent to view",
    sync: "Sync",
    selectDateRange: "Select date range",
    unmatched: "Unmatched",
    errors: "Errors",
    empowerment: "Empowerment",
    withoutEmpowerment: "Legal entity",
    empowermentNeedsMatched: "First select «Matched» = «Yes»",
    organization: "Organization",
    organizations: "Organizations",
    switchOrganization: "Switch organization",
    organizationSwitched: "Organization switched",
    assign: "Assign",
    unassign: "Unassign",
    defaultOrganization: "Default",
    noOrganization: "No organization assigned",
    customer: "Customer",
    setDefault: "Set as default",
    unassignConfirm: "Unassign this organization?",
    all: "All",
    regularInvoices: "Regular invoices",
    hybridInvoices: "Hybrid invoices",
    hybrid: "Hybrid",
    regular: "Regular",
    documentType: "Document type",
    hybridStatus210: "Sent by supplier, waiting for acceptance",
    hybridStatus220: "Cancelled by supplier",
    hybridStatus230: "Rejected by responsible person",
    hybridStatus240: "Accepted by responsible person",
    hybridStatus250: "Responsible person: till return",
    hybridStatus260: "Responsible person: given",
    hybridStatus270: "Rejected by customer",
    hybridStatus280: "Accepted by customer",
    hybridStatus290: "Returned by responsible person",
    hybridStatus300: "Returned by supplier",
    hybridStatus999: "Revoked by tax committee",
    hybridEmpowermentNotSupported: "Accepting a hybrid invoice with empowerment is not supported yet",
    hybridOnlyIncomeAct: "A hybrid invoice can only be matched to an income act",
}
